var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirm-email-container"},[_c('div',{staticClass:"confirm-email-message"},[_vm._v(" Your subscription has expired, please renew to access the content. "),_c('br')])])
}]

export { render, staticRenderFns }